import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { ComponentBaseService } from './component-base.service'
import { ServicesConstants } from '../services-constants'
import { Utils } from '../utils';

@Injectable()
export class FileService extends ComponentBaseService {

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  getServiceName(): string {
    return "FileService";
  }

  getFile(id: number): Observable<any> {
    const url = ServicesConstants.URL_DOCUMENTI + '/' + id + '/download';
    return this.http.get(url, this.httpOptions).pipe(
      tap(doc => this.log(`fetched doc = ${id}`)),
      catchError(this.handleError('getFile', []))
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/_services/file.service.ts